import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilesComponent from 'components/files/files';
const QuestionShortAnswer = ({ questionId, initialState, instructionsFile, getLocalAnswers }) => {
    const { t } = useTranslation();
    const [isDirt, setIsDirt] = useState(false);
    const [textAnswer, setTextAnswer] = useState(undefined);
    useEffect(() => {
        setIsDirt(false);
        setTextAnswer(undefined);
    }, [questionId]);
    // Initialize question
    useEffect(() => {
        if (isDirt) {
            return;
        }
        if (!initialState || !(initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer)) {
            return;
        }
        setTextAnswer(initialState.userAnswer);
    }, [initialState, isDirt]);
    useEffect(() => {
        if (textAnswer === undefined) {
            return;
        }
        if ((initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer) === textAnswer) {
            return;
        }
        setIsDirt(true);
        getLocalAnswers(textAnswer);
    }, [textAnswer]);
    return (_jsxs(_Fragment, { children: [_jsx("form", Object.assign({ className: "form--student-exam" }, { children: _jsxs("fieldset", { children: [_jsx("label", Object.assign({ htmlFor: "shortAnswerUserResponse", className: 'd-none' }, { children: t('SHORT_ANSWER.WRITE_YOUR_ANSWER') }), void 0), _jsx("textarea", { className: "input p-3", id: "shortAnswerUserResponse", maxLength: 500, value: textAnswer !== null && textAnswer !== void 0 ? textAnswer : '', onChange: event => {
                                if (textAnswer !== undefined && event.target.value === undefined) {
                                    setTextAnswer(' ');
                                }
                                else {
                                    setTextAnswer(event.target.value);
                                }
                            } }, void 0)] }, void 0) }), void 0), _jsx(FilesComponent, { file: instructionsFile }, void 0)] }, void 0));
};
export default QuestionShortAnswer;
